import React from 'react'

import { PlatformsListStyled, PlatformsListItemStyled } from './styles'
import { PlatformsListProps } from './types'

import PlatformBox from '../../molecules/PlatformBox'

const PlatformsList: React.FC<PlatformsListProps> = ({ listItems }) => (
  <PlatformsListStyled>
    {listItems.map((item) => (
      <PlatformsListItemStyled key={item.head}>
        <PlatformBox head={item.head} platforms={item.platforms} />
      </PlatformsListItemStyled>
    ))}
  </PlatformsListStyled>
)

export default PlatformsList
